import { FieldErrors, UseFormRegister, UseFormSetValue } from "react-hook-form";
import { CreateEmpresa } from "../types";
import { EmpresaFiltersData } from "../../../../types/filter";
import { InputCreateEmpresaForm } from "../../../../components/ui/InputCreateEmpresaForm";
import { SelectCreateEmpresaForm } from "../../../../components/ui/SelectCreateEmpresaForm";
import { SwitchInput } from "../../../../components/ui/SwitchInput";
import { useEffect, useState } from "react";

interface Props {
    register: UseFormRegister<CreateEmpresa>;
    errors: FieldErrors<CreateEmpresa>;
    selectValues: EmpresaFiltersData;
    setValue: UseFormSetValue<CreateEmpresa>;
}

export function DatosGeneralesSection({ register, errors, selectValues, setValue }: Props) {
    const [formatoMeses, setFormatoMeses] = useState<boolean>(true);

    useEffect(() => {
        setValue("formatoMeses", formatoMeses);
    }, [formatoMeses]);

    return (
        <div className="flex gap-x-2">
            <div className="w-[200px]">
                <p className="text-xl font-semibold">Datos generales</p>
            </div>

            <div>

                <div className="flex gap-x-4 mb-2">
                    <div>
                        <InputCreateEmpresaForm
                            height="h-[35px]"
                            width="w-[300px]"
                            label="Nombre"
                            register={register("nombre", {
                                required: "El nombre de la empresa es requerido",
                                maxLength: 100
                            })}/>

                        <div className="h-[20px]">
                            {errors.nombre?.type === "required" && (
                                <p className="valErrorText text-sm">{errors.nombre.message}</p>
                            )}
                            {errors.nombre?.type === "maxLength" && (
                                <p className="valErrorText text-sm">Número máximo de caracteres es 100</p>
                            )}
                        </div>
                    </div>

                    <div>
                        <InputCreateEmpresaForm 
                            height="h-[35px]"
                            width="w-[300px]"
                            label="Sucursal"
                            register={register("sucursal", {
                                maxLength: 40
                            })}/>
                        <div className="h-[20px]">
                            {errors.sucursal?.type === "maxLength" && (
                                <p className="valErrorText text-sm">Número máximo de caracteres es 40</p>
                            )}
                        </div>
                    </div>

                    <div>
                        <InputCreateEmpresaForm 
                            height="h-[35px]"
                            width="w-[300px]"
                            label="Num. Trabajadores"
                            type="number"
                            register={register("numeroTrabajadores", {
                                required: "El número de trabajadores es requerido"
                            })}/>
                        <div className="h-[20px]">
                            {errors.numeroTrabajadores?.type === "required" && (
                                <p className="valErrorText text-sm">{errors.numeroTrabajadores.message}</p>
                            )}
                        </div>
                    </div>
                </div>

                <div className="flex gap-x-4 mt-2">
                    <div>
                        <SelectCreateEmpresaForm
                            height="h-[35px]"
                            width="w-[300px]"
                            label="Estado"
                            register={register("estadoId", {
                                required: "El estado de la empresa es requerido",
                                min: 1,
                            })}
                            datos={selectValues.estadosEmpresa.map((estado, index) => (
                                <option key={index} value={estado.id}>{estado.nombre}</option>
                            ))}/>
                        <div className="h-[20px]">
                            {errors.estadoId?.type === "required" && (
                                <p className="valErrorText text-sm">{errors.estadoId.message}</p>
                            )}
                            {errors.estadoId?.type === "min" && (
                                <p className="valErrorText text-sm">El estado de la empresa es requerido</p>
                            )}
                        </div>
                    </div>

                    <div>
                        <SelectCreateEmpresaForm 
                            height="h-[35px]"
                            width="w-[300px]"
                            label="Tipo de empresa"
                            register={register("tipoEmpresaId", {
                                required: "El tipo de empresa es requerido",
                                min: 1,
                            })}
                            datos={selectValues.tiposEmpresa.map((tipo, index) => (
                                <option key={index} value={tipo.id}>{tipo.nombre}</option>
                            ))}/>
                        <div className="h-[20px]">
                            {errors.tipoEmpresaId?.type === "required" && (
                                <p className="valErrorText text-sm">{errors.tipoEmpresaId.message}</p>
                            )}
                            {errors.tipoEmpresaId?.type === "min" && (
                                <p className="valErrorText text-sm">El estado de la empresa es requerido</p>
                            )}
                        </div>
                    </div>

                </div>

                <div className="flex gap-x-4 mb-2">
                    <div>
                        <div className="grid w-[300px]">
                            <label className="text-sm font-semibold">Formato de frecuencia</label>
                            <SwitchInput
                                setFormatoMeses={setFormatoMeses}
                                formatoMeses={formatoMeses}/>
                        </div>
                    </div>

                    <div>
                        <div className="grid">
                            <label className="text-sm font-semibold">Frecuencia de visitas</label>
                            {formatoMeses
                            ?
                            <select
                                {...register("frecuenciaVisita", {
                                    required: "La frecuencia de visita es requerida",
                                    minLength: 1,
                                    min: 1
                                })}
                                className={`h-[35px] w-[300px] rounded-[3px] border-gray-400 border px-2 
                                    font-semibold text-gray-600 text-sm`} >
                                <option value={0} hidden>Seleccionar frecuencia</option>
                                {selectValues.frecuencia.map((frecuencia, index) => (
                                    <option key={index} value={frecuencia}>{frecuencia}</option>
                                ))}
                            </select>
                            :
                            <input
                                {...register("frecuenciaVisita", {
                                    required: "La frecuencia de visita es requerida",
                                    minLength: 1,
                                })}
                                type={"date"}
                                className={`h-[35px] w-[300px] rounded-[3px] border-gray-400 border px-2 
                                    font-semibold text-gray-600 text-sm`} />
                            }
                            <div className="h-[20px]">
                                {errors.frecuenciaVisita?.type === "required" && (
                                    <p className="valErrorText text-sm">{errors.frecuenciaVisita.message}</p>
                                )}
                                {errors.frecuenciaVisita?.type === "min" && (
                                    <p className="valErrorText text-sm">La frecuencia de visita es requerida</p>
                                )}
                            </div>
                        </div>
                    </div>

                </div>

            </div>

        </div>
    );
}
